import React from 'react';
import {
  WhiteInstantSearchBuilder,
  AutocompleteHeader,
  AutocompleteItem,
  AutocompleteProductItem,
  AutocompleteHighlight,
} from '@white-nl/instantsearch-components';

const searchBar = document.querySelector('#white-instant-search-search-box-global');
if (searchBar) {
  const { searchUrl } = (searchBar as HTMLDivElement).dataset;
  const whiteInstantSearchSearchBar = new WhiteInstantSearchBuilder();
  whiteInstantSearchSearchBar
    .addAutocompleteSearchingComponent([
      {
        settings: {
          placeholder: Craft.t('search', 'What are you looking for?'),
          classNames: {
            panel: 'autocomplete-global',
          },
          sources: [
            {
              getQueryParams: (query, defaultFilters?) => ({
                query,
                filters: `type:01Products ${(defaultFilters ? `AND (${defaultFilters})` : '')}`,
              }),
              transformResponse: ({ hits }) => ((hits[0] || []).map((hit: any) => ({ ...hit }))),
              templates: {
                header: () => (<AutocompleteHeader title={Craft.t('search', 'Products')} />),
                item: ({
                  item,
                  components,
                  source,
                  state,
                }) => (
                  <AutocompleteProductItem
                    hit={item}
                    url={source.getItemUrl!({ item, state })!}
                    components={{ ...components, Highlight: AutocompleteHighlight }}
                    descriptionAttribute="description"
                    ratingAttribute="rating"
                    commentsAttribute="comments"
                    priceAttribute="defaultPrice"
                    salePriceAttribute="defaultSalePrice"
                    onFillQuery={() => source.onFillQuery({ item, state })}
                  />
                ),
              },
            },
            {
              getQueryParams: (query, defaultFilters?) => ({
                query,
                filters: `NOT type:01Products ${(defaultFilters ? `AND (${defaultFilters})` : '')}`,
              }),
              templates: {
                item: ({
                  item,
                  components,
                  source,
                  state,
                }) => (
                  <AutocompleteItem
                    hit={item}
                    url={source.getItemUrl!({ item, state })!}
                    components={{ ...components, Highlight: AutocompleteHighlight }}
                    onFillQuery={() => source.onFillQuery({ item, state })}
                  />
                ),
              },
            },
          ],
          onSubmit: (query: string) => {
            window.location.href = `${searchUrl}?query=${query}`;
          },
        },
      },
    ], '#white-instant-search-search-box-global');
  window.whiteInstantSearchSearchBar = whiteInstantSearchSearchBar;
}
